"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Brain, HeartHandshake, Users, UserPlus, House, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Psychogeriatrische zorg",
  description: "Gespecialiseerde en warme zorg voor mensen met dementie, afgestemd op hun persoonlijke belevingswereld en behoeften.",
  icon: Brain,
  href: "/CareServicesPage"
}, {
  title: "Psychische ondersteuning",
  description: "Deskundige begeleiding en ondersteuning bij psychische en psychiatrische problematiek in de vertrouwde thuissituatie.",
  icon: HeartHandshake,
  href: "/CareServicesPage"
}, {
  title: "Persoonlijke begeleiding",
  description: "Hulp bij het structureren van de dag, administratie en het onderhouden van een gezond sociaal netwerk.",
  icon: Users,
  href: "/CareServicesPage"
}, {
  title: "Persoonlijke verzorging",
  description: "Respectvolle ondersteuning bij dagelijkse handelingen zoals wassen, aankleden en verantwoord medicatiegebruik.",
  icon: UserPlus,
  href: "/CareServicesPage"
}, {
  title: "Huishoudelijke hulp",
  description: "Praktische en betrouwbare ondersteuning in het huishouden voor een schone, veilige en leefbare woonomgeving.",
  icon: House,
  href: "/CareServicesPage"
}];
export default function OnzeZorgdiensten() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="onze-zorgdiensten" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
            Onze Zorgdiensten
          </h2>
          <p className="text-lg text-muted-foreground">
            Wij bieden persoonsgerichte zorg en ondersteuning aan huis, afgestemd op uw unieke situatie, wensen en culturele achtergrond.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className="h-full">
                <Link to={service.href} className="block h-full group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl">
                  <Card className="h-full bg-card border-border/40 transition-all duration-300 ease-out group-hover:-translate-y-2 group-hover:shadow-xl group-hover:shadow-primary/10 group-hover:border-primary/30 flex flex-col">
                    <CardHeader className="pb-4">
                      <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center mb-4 text-primary group-hover:scale-110 transition-transform duration-300 ease-out">
                        <Icon className="w-6 h-6" strokeWidth={1.5} />
                      </div>
                      <CardTitle className="text-lg font-semibold leading-tight group-hover:text-primary transition-colors duration-300">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-grow flex flex-col justify-between">
                      <CardDescription className="text-muted-foreground text-sm leading-relaxed mb-6">
                        {service.description}
                      </CardDescription>
                      <div className="flex items-center text-sm font-medium text-primary opacity-80 group-hover:opacity-100 transition-opacity mt-auto">
                        Lees meer
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}